<template lang="pug">
.profile-screen
  ul#myTab.nav.nav-tabs
    li.nav-item.active
      button.nav-link.active(
        data-bs-target='#tab__signatures'
        data-bs-toggle='tab'
      ) {{ $t('pages.profile.signatures') }}
    li.nav-item
      button.nav-link(data-bs-target='#tab__myaccount' data-bs-toggle='tab') {{ $t('pages.profile.myAccount') }}
  .tab-content.profile-page
    #tab__signatures.tab-pane.fade.show.active(
      aria-labelledby='home-tab'
      role='tabpanel'
    )
      .row.mb-5(v-if='!signature && !initial')
        .no-envelope
          .text-center.mb-5
            img.img-fluid.mt-5.img.mb-3.without-img(
              src='/img/ilustrations/no-signature.svg'
              style='max-height: 260px'
            )
            .text.font-color-blue {{ $t('pages.profile.noSignature') }}
            .text.font-color-blue {{ $t('pages.profile.startWithSignature') }}
            .mt-3
              button.btn.btn-primary.signature-create(
                @click='editSignature("signature")'
                type='button'
              ) {{ $t('pages.profile.createSignature') }}
      .row.mt-4(v-else)
        .col-12.col-sm-6.col-lg-4.col-xl-3.mb-3
          h5.title-dark.mb-3 {{ $t('pages.profile.signature') }}
          .card.signature--card(
            :class='{ "signature--card--loading": this.loadingSignature }'
            v-if='signature'
          )
            .card-body
              button.action-remove(
                :title='$t("pages.profile.editSignature")'
                @click='editSignature("signature")'
                type='button'
              )
                icon(name='pen-to-square')
              .signature-img
                .loading-text {{ $t('pages.profile.loading') }}
                img.img(:src='signature')
          .mt-2(v-else)
            button.btn.btn-primary(
              @click='editSignature("signature")'
              type='button'
            ) {{ $t('pages.profile.createSignature') }}
        .col-12.col-sm-6.col-lg-4.col-xl-3
          h5.title-dark.mb-3 {{ $t('pages.profile.initial') }}
          .card.signature--card(
            :class='{ "signature--card--loading": this.loadingInitial }'
            v-if='initial'
          )
            .card-body
              button.action-remove(
                :title='$t("pages.profile.editInitial")'
                @click='editSignature("initial")'
                type='button'
              )
                icon(name='pen-to-square')
              .signature-img
                .loading-text {{ $t('pages.profile.loading') }}
                img.img(:src='initial')
          .mt-2(v-else)
            button.btn.btn-primary.rubrica-create(
              @click='editSignature("initial")'
              type='button'
            ) {{ $t('pages.profile.createInitial') }}
    #tab__myaccount.tab-pane.fade
      span.my-3.d-flex.flex-column.mt-3.title-dark {{ $t('pages.profile.accessData') }}
      .profile-page.mt-3
        .row(:style='"cursor: " + cursorStyle')
          .col-12
            .card.card--rounded.flex-row.mb-5(name='profile')
              .card-body.card-body--user-info
                ValidationObserver(ref='form' v-slot='{ valid }')
                  .row.profile-inputs
                    .col-12.col-md-6.form-group
                      label(for='name') {{ $t('pages.profile.name') }}
                      .form-control-icon
                        icon(name='user')
                        input.form-control(
                          :placeholder='$t("pages.profile.namePlaceholder")'
                          autocomplete='off'
                          type='name'
                          v-model='user.name'
                        )
                    .col-12.col-md-6.form-group
                      ValidationProvider(
                        name='phone'
                        rules='internationalPhone'
                        v-slot='{ errors }'
                      )
                        label(for='phone') {{ $t('pages.profile.phone') }}
                        .form-control-icon
                          input-tel#phone.form-control(
                            autocomplete='off'
                            type='text'
                            v-model='user.phone'
                          )
                        small.align-items-center.text.text-danger.d-flex.mt-1(
                          v-if='errors.length > 0'
                        )
                          icon(name='xmark')
                          span.text.ms-2 {{ errors[0] }}
                    .col-12.col-md-6.form-group
                      label(for='email') {{ $t('pages.profile.email') }}
                      .form-control-icon
                        icon(name='at')
                        input#email.form-control(
                          :placeholder='$t("pages.profile.emailPlaceholder")'
                          autocomplete='off'
                          disabled
                          type='email'
                          v-model='$root.user.email'
                        )
                    .col-12.col-md-6.form-group(v-if='!$root.isUSAVersion')
                      ValidationProvider(
                        name='cpf'
                        rules='required|cpf'
                        v-slot='{ errors }'
                      )
                        label(for='cpf') {{ $t('pages.profile.cpf') }}
                        .form-control-icon
                          icon(name='id-card')
                          input#cpf.form-control(
                            :placeholder='$t("pages.profile.cpfPlaceholder")'
                            autocomplete='off'
                            type='cpf'
                            v-mask='["###.###.###-##"]'
                            v-model='user.cpf'
                          )
                        small.align-items-center.text.text-danger.d-flex.mt-1(
                          v-if='errors.length > 0'
                        )
                          icon(name='xmark')
                          span.text.ms-2 {{ errors[0] }}
                    .col-12.d-flex.align-items-center.action-buttons
                      a.text--change-password(
                        data-bs-target='#change-password-modal'
                        data-bs-toggle='modal'
                        href='#'
                      ) {{ $t('pages.profile.changePassword') }}
                      a.text--change-password.text--delete-account.ms-4(
                        data-bs-target='#delete-account-modal'
                        data-bs-toggle='modal'
                        href='#'
                        v-if='canEnableDeleteAccount'
                      ) {{ $t('pages.profile.deleteAccount') }}
                      .ms-auto.button__save-changes
                        button.btn.btn-primary(
                          :disabled='!valid || canSubmit'
                          @click='submit'
                          style='margin-left: 2rem'
                          type='button'
                        ) {{ $t('pages.profile.saveChanges') }}

  change-password-modal(ref='changePasswordModal')
  delete-account-modal(@continue='startDeleteFlow' ref='deleteAccountModal')
  delete-account-organizations-owner-modal(
    :organizations='organizations'
    @review-actions-organizations-owner='reviseOwnersOrganizationsActions($event)'
    ref='deleteAccountOrganizationsOwnerModal'
  )
  delete-account-review-actions-organizations-owner-modal(
    :organization-decisions='organizationDecisions'
    :review-items='reviewItems'
    @process='initConfirmationCode'
    ref='deleteAccountReviewActionsOrganizationsOwnerModal'
  )
  delete-account-confirmation-code-modal(
    :expire-at='confirmationCodeExpireAt'
    :is-resending='loading'
    @process='confirmDeleteAccount($event)'
    @resend-code='generateConfirmationCode'
    ref='deleteAccountConfirmationCodeModal'
  )
  //- Modal de assinaturas
  signature-creator-modal#signature-creator-modal(
    :default-text='signatureModalDefaultText'
    :label='signatureModalLabel'
    :signature-text-max-length='signatureModalTextLength'
    @change-signature='onSignatureUpdate'
    ref='signatureCreatorModal'
  )
  signature-created-modal(
    @process='editSignature("initial")'
    ref='signatureCreatedModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import ChangePasswordModal from '@/modules/account/components/organisms/modals/ChangePasswordModal.vue';
import SignatureCreatedModal from '@/modules/account/components/organisms/modals/SignatureCreatedModal.vue';
import SignatureCreatorModal from '@/ui/organisms/modals/SignatureCreatorModal.vue';
import AccountService from '@/services/AccountHttp';
import SignatureService from '@/services/SignatureHttp';
import alert from '@/modules/account/common/alert';
import Abbreviator from '@/services/Abbreviator';
import InputTel from '@/ui/molecules/InputTel.vue';
import processData from '@/utils/processData';
import DeleteAccountModal from '@/modules/account/components/organisms/modals/DeleteAccountModal.vue';
import config from '@/config';
import BackupService from '@/modules/account/services/http/BackupService';
import formHandler from '@/modules/account/common/formHandler';
import DeleteAccountOrganizationsOwnerModal from '@/modules/account/components/organisms/modals/DeleteAccountOrganizationsOwnerModal.vue';
import DeleteAccountReviewActionsOrganizationsOwnerModal from '@/modules/account/components/organisms/modals/DeleteAccountReviewActionsOrganizationsOwnerModal.vue';
import OrganizationService from '@/modules/account/services/http/OrganizationService';
import DeleteAccountConfirmationCodeModal from '@/modules/account/components/organisms/modals/DeleteAccountConfirmationCodeModal.vue';
import verificationCodeUserRequests from '@/modules/account/services/http/VerificationCodeService';
import Logger from '@/services/Logger';
import appConfig from '@/config';

export default {
  name: 'ProfilePage',
  data() {
    return {
      signature: '',
      initial: '',
      loading: false,
      idToDelete: null,
      user: {
        name: this.$root.user.name,
        phone: this.$root.user.phone,
        cpf: this.$root.user.cpf,
      },
      inEditionSignatureType: null,
      signatureModalLabel: 'Assinatura',
      signatureModalTextLength: 30,
      signatureModalDefaultText: null,
      loadingSignature: false,
      loadingInitial: false,
      organizationDecisions: [],
      reviewItems: [],
      organizations: [],
      loadingOrganizations: false,
      deleteFlowStarted: false,
      confirmationCodeExpireAt: '',
    };
  },
  components: {
    DeleteAccountConfirmationCodeModal,
    Icon,
    InputTel,
    ChangePasswordModal,
    SignatureCreatorModal,
    SignatureCreatedModal,
    DeleteAccountModal,
    DeleteAccountOrganizationsOwnerModal,
    DeleteAccountReviewActionsOrganizationsOwnerModal,
  },
  computed: {
    cursorStyle() {
      return this.loading ? 'wait' : '';
    },
    canSubmit() {
      if (
        this.user.name !== this.$root.user.name ||
        this.user.phone !== this.$root.user.phone ||
        this.user.cpf !== this.$root.user.cpf
      ) {
        return false;
      }
      return true;
    },
    canEnableDeleteAccount() {
      return config.enableAnonymization;
    },
  },
  created() {
    this.$store.dispatch('page/setTitle', this.$t('pages.index.profile'));
    this.$store.dispatch('page/setHead', this.$t('pages.index.profile'));
    this.$store.dispatch('page/setClass', 'account profile');
    this.loadInitial();
    this.loadSignature();
    this.avatar = this.$root.user.avatar;
  },
  methods: {
    async submit() {
      const userData = {
        name:
          this.user.name !== this.$root.user.name && this.user.name !== ''
            ? this.user.name
            : this.$root.user.name,
        phone:
          this.user.phone !== this.$root.user.phone && this.user.phone !== ''
            ? this.user.phone
            : this.$root.user.phone,
        cpf:
          this.user.cpf !== this.$root.user.cpf && this.user.cpf !== ''
            ? processData.extractOnlyNumbers(this.user.cpf)
            : processData.extractOnlyNumbers(this.$root.user.cpf),
      };

      if (this.$root.isUSAVersion) {
        delete userData.cpf;
      }

      await AccountService.setUser(userData)
        .then(() => {
          this.$root.user.name = this.user.name;
          this.$root.user.phone = this.user.phone;
          this.$root.user.cpf = processData.extractOnlyNumbers(this.user.cpf);
          alert.fireAlert(this.$t('pages.profile.userUpdatedSuccess'), {
            classes: 'alert-success',
            styles:
              'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
            icon: 'circle-check',
          });
        })
        .catch((error) => {
          const errorMessage = error.response.data.errors.phone
            ? this.$t('pages.profile.phoneExistsError')
            : this.$t('pages.profile.updateError');
          alert.fireAlert(errorMessage, {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          });
        });
    },
    confirmDeleteAccount(code) {
      const payload = {
        request_type: 'anonimization',
        metadata: {
          workspace: this.$store.state.organizations.selected.id,
          date_start: '',
          date_end: '',
          include_background_sheet: false,
          include_storage_documents: false,
        },
        verification_code: code,
      };

      if (!payload.verification_code) {
        console.error('Not found verification code.');
        return;
      }

      if (this.organizationDecisions.length > 0) {
        const workspaces = {};
        this.organizationDecisions.forEach((workspace) => {
          switch (workspace.action) {
            case 'delete':
              workspaces[workspace.organizationId] = {
                anonymize: true,
                change_owner: false,
                new_owner: null,
              };
              break;
            case 'transfer':
              workspaces[workspace.organizationId] = {
                anonymize: false,
                change_owner: true,
                new_owner: workspace.newOwnerId,
              };
              break;
            case 'leave':
            default:
              workspaces[workspace.organizationId] = {
                anonymize: false,
                change_owner: false,
                new_owner: null,
              };
              break;
          }
        });

        payload.metadata.workspaces = workspaces;
      }

      formHandler.submit(this, () => BackupService.create(payload), {
        successHandler: async (response) => {
          formHandler.defaultSuccess(response);

          if (response.status === 201) {
            window.location.assign(
              `${appConfig.loginPath}?continue=${window.location}`
            );
          }
        },
        errorHandler: (error) => {
          const status = error.response?.status;
          const errorCode = error.code;
          const message = error.response?.data?.message?.toLowerCase?.() || '';

          const isTimeout =
            status === 504 ||
            errorCode === 'ECONNABORTED' ||
            errorCode === 'ETIMEDOUT' ||
            message.includes('timeout') ||
            message.includes('timed out');

          if (isTimeout) {
            window.location.reload();
            return;
          }

          formHandler.defaultError(this, error, {});
        },
      });
    },
    async loadOrganizations() {
      try {
        this.loadingOrganizations = true;
        const response = await OrganizationService.listOnwerOrganizations();
        this.organizations = response.data.data || [];
      } finally {
        this.loadingOrganizations = false;
      }
    },
    async startDeleteFlow() {
      this.deleteFlowStarted = true;
      await this.loadOrganizations();
      if (!this.organizations.length) {
        this.reviseOwnersOrganizationsActions({
          organizationDecisions: [],
          reviewItems: [],
        });
        return;
      }
      this.openAnonymizeOrganizationsModal();
    },
    async generateConfirmationCode() {
      try {
        this.loading = true;
        const response = await verificationCodeUserRequests.generateCode(
          this.$root.user.id
        );
        this.confirmationCodeExpireAt = response.data.expire_at;
        alert.fireAlert(
          this.$t('pages.profile.generateConfirmationCodeSuccess'),
          {
            classes: 'alert-success',
            styles:
              'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
            icon: 'circle-check',
          }
        );
      } catch (error) {
        this.confirmationCodeExpireAt = '';
        Logger.consoleError('Cannot generate confirmation code:', error);
        alert.fireAlert(
          this.$t('pages.profile.generateConfirmationCodeError'),
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          }
        );
      } finally {
        this.loading = false;
      }
    },
    openAnonymizeOrganizationsModal() {
      this.$refs.deleteAccountOrganizationsOwnerModal.$refs.modal.open();
    },
    openReviewActionsOrganizationsOwnerModal() {
      this.$refs.deleteAccountReviewActionsOrganizationsOwnerModal.$refs.modal.open();
    },
    openConfirmationCodeModal() {
      this.$refs.deleteAccountConfirmationCodeModal.$refs.modal.open();
    },
    async initConfirmationCode() {
      this.$refs.deleteAccountReviewActionsOrganizationsOwnerModal.$refs.modal.close();
      await this.generateConfirmationCode();
      this.openConfirmationCodeModal();
    },
    reviseOwnersOrganizationsActions(payload) {
      this.organizationDecisions = payload.organizationDecisions;
      this.reviewItems = payload.reviewItems;
      this.$refs.deleteAccountOrganizationsOwnerModal.$refs.modal.close();
      this.openReviewActionsOrganizationsOwnerModal();
    },
    loadInitial() {
      this.loadingInitial = true;
      SignatureService.getSignature('initial').then((res) => {
        this.initial = res;
        this.loadingInitial = false;
      });
    },
    loadSignature() {
      this.loadingSignature = true;
      SignatureService.getSignature('signature').then((res) => {
        this.signature = res;
        this.loadingSignature = false;
      });
    },
    editSignature(type) {
      this.$refs.signatureCreatedModal.$refs.modal.close();
      if (type === 'signature') {
        this.inEditionSignatureType = 'signature';
        this.signatureModalDefaultText = this.$root.user.name;
        this.signatureModalLabel = this.$t('pages.profile.signature');
        this.signatureModalTextLength = 30;
        this.$refs.signatureCreatorModal.$refs.modal.open();
        return;
      }
      this.inEditionSignatureType = 'initial';
      this.signatureModalDefaultText = Abbreviator.get(this.$root.user.name);
      this.signatureModalLabel = this.$t('pages.profile.initial');
      this.signatureModalTextLength = 5;
      this.$refs.signatureCreatorModal.$refs.modal.open();
    },
    onSignatureUpdate(data) {
      if (!this.signature) {
        this.$refs.signatureCreatedModal.$refs.modal.open();
      }
      if (this.inEditionSignatureType === 'signature') {
        this.loadingSignature = true;
      } else {
        this.loadingInitial = true;
      }
      SignatureService.saveSignature(
        this.inEditionSignatureType,
        data.blob
      ).then(() => {
        if (this.inEditionSignatureType === 'signature') {
          this.loadSignature();
        } else {
          this.loadInitial();
        }
      });
    },
  },
};
</script>
<style lang="stylus">
.profile-page
  .signature--card
    border-left: 5px solid #3ECB90
  .signature-img
    .img
      max-width: 100%
      // width: 100%
      max-height: 6rem
  .title-dark
    color: #013D52
  .text--change-password
    font-size: 1rem
    color: #01AFEC
  .text--delete-account
    color:#E74C3C

  .file
    input[type="file"]
      display: none;

    color: #0d6efd;
    cursor: pointer;
    margin-top: 3px;
    margin-right: 60px;

    &:hover
      opacity: 0.5;
      transition: opacity .1s;

  .loading-text
    display: none
    position: absolute
    margin: auto
    left: 0
    right: 0
    top: 0
    bottom: 0
    height: 1.6em
    padding-left: 1em
  .signature--card--loading
    .img
      opacity: 0
    .loading-text
      display: block

  .card-body--user-info
    padding: 1.438rem 2rem
  .card-body
    [class^="action"]
      cursor: pointer;
      position: absolute;
      color: #949494;
      right: 10px;

      &:hover
        opacity: 0.6;
        transition: opacity .3s;

    .action-remove
      top: 10px;
      color: #013D52

    .action-default
      top: 10px;

      &.active
        color: #54AA5A !important;
  #tab__myaccount
    span
      font-size: 0.875rem
@media (max-width: 991px)
  .without-img
    width: 100%
  .signature-create
    width: 100%
  .rubrica-create
    width: 100%
  .action-buttons
    display: flex
    flex-direction: column
    .text--change-password
      align-self: start
    .text--delete-account
      color:#E74C3C
    .button__save-changes
      margin-top: 1rem
      width: 100%
      margin-left: 0 !important
      button
        width: 100%
        margin-left: 0 !important
  .profile-inputs
    display: flex
    flex-direction: column
    .form-group
      width: 100%
</style>
